import React, { Component } from 'react'
import { List, Map, Set } from 'immutable'
import PropTypes from 'prop-types'
import ImmutablePropTypes from 'react-immutable-proptypes'

import CombinedOffer from './CombinedOffer'

import OfferGroupHeading from './OfferGroupHeading'
import scrollToComponent from 'react-scroll-to-component';

/** Renders a single CombinedOfferGroup - for a FlightRequirement - (potentially within a number of such groups).
 * Independently manages the filters for, and selection, within this offergroup,
 * but with filters showing/hiding controlled externally, in order to show/hide
 * filters across all offer groups with one UI control.
 */
class FlightCombinedOfferGroup extends Component {

  constructor(){
    super()
    this.state ={
      showUnselected: false
    }
  }

  toggleShowUnselected() {
    this.setState({showUnselected: !this.state.showUnselected})
  }

  selectOffer(uri,ref) {   
    this.props.selectOffer(uri)
    this.setState({ showUnselected: false }, ()=>{
      scrollToComponent(ref, { offset: -96, align: 'top', duration: 500, ease:'inQuad'})
    })
  }

  unselectOffer(uri,ref) {
    this.props.unselectOffer(uri)
    this.setState( { showUnselected: true }, ()=>{
      scrollToComponent(ref, { offset: -46, align: 'top', duration: 500, ease:'inQuad'})
    })
  }

  render()
  {
    const {
      offerGroup = Map(),
      combinedOffersIndex,

      groupNo = 0,
      filterFn,
      passengerCount,
      airportByIata = Map(),
      showHeading = false,

      selectedOffers = Set(),

      showMoreOptions
    } = this.props

    const { showUnselected } = this.state

    const hasSelection = offerGroup.get('combinedOffer', List()).some(o => o.get('offerURIs').some( offer => selectedOffers.includes(offer)))

    // Logic to decide if a given offer is shown or hidden
    // (per-offer flag is set)
    // FIXME we are setting the requested services in the offer. this is used for TimeOfDay filtering.
    // FIXME !! NO FILTERS YET - for combined offers, requested is already side offer (serviceAlternative)

    const offers = offerGroup.get('combinedOffer', List()).map(o =>
        o.set('match',
            o.get('offerURIs').some( offer => selectedOffers.includes(offer)) ||
              ((filterFn ? filterFn(o.set('requested', offerGroup.get('requested'))) : true) &&
            (!hasSelection || showUnselected)
            )
        ))

    return <div className="offer-group">
        <OfferGroupHeading showHeading={showHeading}  offerGroup={offerGroup} index={groupNo} view="book-a-flight">
          {/* If we have a selection, and multiple options to select from */}
          {hasSelection && offers.size > 1 &&
              <div className="show-hide-controls" style={{float:'right'}}>
                  {!showUnselected &&
                      <button className="btn btn-sm btn-secondary show-unselected" onClick={this.toggleShowUnselected.bind(this)}>{filterFn
                          ? `Show all (that match filters)`
                          : `Show all ${offers.size}`}
                      </button>
                  }
                  {showUnselected &&
                      <button className="btn btn-sm btn-secondary hide-unselected"
                          onClick={this.toggleShowUnselected.bind(this)}>Hide unselected</button>
                  }
              </div>
          }
        </OfferGroupHeading>

        {offers.map((o = Map(), index) => {
            return <CombinedOffer offer={o} key={index} ogIndex={groupNo} combinedOffersIndex={combinedOffersIndex} showMoreOptions={showMoreOptions} selectedOffers={selectedOffers} selectOffer={this.selectOffer.bind(this)} unselectOffer={this.unselectOffer.bind(this)} airportByIata={airportByIata} passengerCount={passengerCount}/>
          })
        }
        {(offers.size === 0 || offers.every((o = Map()) => !o.get('match'))) &&
            <div className="no-results-placeholder" key="none">
                No results match your criteria
            </div>
        }

    </div>
  }
}

FlightCombinedOfferGroup.propTypes = {
    offerGroup: ImmutablePropTypes.map.isRequired,
    // Map<IataCode, AirportDetail>
    airportByIata: ImmutablePropTypes.map,
    // The number of passengers that these offers are for
    // (hack, but this is not in the offerGroups part of the data structure)
    // Instead, probably pass through 'requested' info
    passengerCount: PropTypes.number.isRequired,

    // Optional filter (predicate function)
    // offerFilter :: Offer -> Bool
    filterFn: PropTypes.func,

    // Add a given offer URI to the user selection
    // selectOffer :: String -> ()
    selectOffer: PropTypes.func,

    // Remove a given offer URI from the user selection
    // unselectOffer :: String -> ()
    unselectOffer: PropTypes.func,

    // Set<OfferURI> - the current user selection
    selectedOffers: ImmutablePropTypes.setOf(PropTypes.string)
}


//
// /* Enhances OfferGroup with a stateful 'showUnselected' property
//    and a toggle function, as well as filtering and selecting logic. */
// const enhance = withStateHandlers(
//     // Initial state
//     {
//         showUnselected: false
//     },
//     // Handlers
//     {
//         toggleShowUnselected: ({ showUnselected }) => () => ({
//             showUnselected: !showUnselected
//         }),
//
//         // Override behaviour of 'select' and 'unselect' accordingly
//         selectOffer: (_, { selectOffer }) => uri => {
//             selectOffer(uri)
//             return { showUnselected: false }
//         },
//         unselectOffer: (_, { unselectOffer }) => uri => {
//             unselectOffer(uri)
//             return { showUnselected: true }
//         }
//     }
// )

// export default enhance(FlightCombinedOfferGroup)
export default FlightCombinedOfferGroup



// WEBPACK FOOTER //
// ./src/ndc/offer/FlightCombinedOfferGroup.js